// removed by extract-text-webpack-plugin
module.exports = {"horizontal":"src-components-commons-Pattern-style----rotation-module---horizontal---3gng2","vertical":"src-components-commons-Pattern-style----rotation-module---vertical---2jqh5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/commons/Pattern/style/rotation.module.css
// module id = 1427
// module chunks = 168707334958949